export const energyConsumptionReportSx = {
  root: {
    py: 3,
    gap: 2
  }
}
